import { List } from "./list/Index"
import { Setup } from "./setup/Index"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"

import { FeatureIdState } from "../../toolUsage/global/GlobalFcn"
import { CreateFeatureLogs } from "../../global/API"

export const BranchProduct = ({match}) => {
    
    
    const { tool_state } = useContext(ToolContext)
    const { __SESSION } = tool_state

    let loc = match.params.params

    const tool_id = process.env.REACT_APP_TID_BIZ;

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('setup')}->4`,
            feature_id: 4,
            feature_name: "branch-product-setup",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }   

    useEffect(() => {
        SendFeatureLogs()
        //eslint-disable-next-line
    }, [])

    if (loc === 'list') {
        return <List/>
    }else{
        return( 
            <>
                <Setup loc={loc}/>
            </>
        )
    }
}